export const environment = {
  production: true,
  debugMode: false,
  ENVIRONMENT: 'production',
  registerServiceWorker: true,
  sentryDSN: 'https://a40e8719561d497aa04f7fbec1489d21@errcol.g.placewise.com/4',
  sentryEnvironment: 'production',
  commitId: 'eb82268b1c7adc9c548060c8a71ceadf5844b631',
  webforms_api: '/api',
  passwordMinLength: 8,
  dmpEvents: true,
  recaptchaBaseKey: '6LdG5EAdAAAAAGUBeL81M4-j50ghLBuRhJU8mhzj',
  recaptchaCheckboxKey: '6LfZ3EAdAAAAAERJ6k4U3QPlF6D0jS1Ju3BaFjZt',
  authApi: '/v1',
  mobileEventsDebugEnabled: false,
};
